import $ from 'jquery'
import 'bootstrap'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'

import Vue from 'vue'
import PageHeader from './Components/PageHeader'
import FleetFilter from './Components/FleetFilter'
import ContactSearch from './Components/ContactSearch'
import ContactSearchEmployeeCard from './Components/ContactSearchEmployeeCard'
import ContactSearchLocationCard from './Components/ContactSearchLocationCard'

jQuery = $;
window.jQuery = $;
window._ = require('lodash')

let owl_carousel = require('./owl.carousel');
window.fn = owl_carousel;


jQuery(function () {
  jQuery(".content-toggle").on("click", function (event) {
    event.preventDefault();
    jQuery('.post-detail .toggle-content').toggleClass("expanded");
    if (jQuery(this).text() == 'Less') {
      jQuery(this).text('More');
    } else {
      jQuery(this).text('Less');
    }
  });

  jQuery(".filters .dropdown-item").each(function () {
    var str = jQuery(this).text();
    jQuery(this).click(function () {
      jQuery(this).parent().siblings(".dropdown-toggle").text(str);
    });
  });

});

const pageHeader = document.querySelector('#page-header')
if (pageHeader) {
  pageHeader.vue = new Vue({
    components: {
      'v-page-header': PageHeader,
    },
  }).$mount(pageHeader)
}

const fleetFilter = document.querySelector("#vessel-filter")
if (fleetFilter) {
  fleetFilter.vue = new Vue({
    components: {
      'v-fleet-filter': FleetFilter,
    },
  }).$mount(fleetFilter)
}

const contactSearch = document.querySelector('#contact-search')
if (contactSearch) {
  contactSearch.vue = new Vue({
    components: {
      'v-contact-search': ContactSearch,
    },
  }).$mount(contactSearch)
}

const contactLocation = document.querySelector('#contact-location')
if (contactLocation) {
  contactLocation.vue = new Vue({
    components: {
      'v-contact-search-location-card': ContactSearchLocationCard,
      'v-contact-search-employee-card': ContactSearchEmployeeCard,
    },
  }).$mount(contactLocation)
}
